<template>
  <LegalPage />
</template>